import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import axios from "axios";
import ApiConfig from './../api/ApiConfig';
import { PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../api/ApiServices";

const Notification = ({ navigate }) => {
  const [notificationList, setNotificationList] = useState([]);
  const [notificationListToday, setNotificationListToday] = useState([]);
  const [notificationListEarly, setNotificationListEarly] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const scrollRef = useRef(null);

  const profileData = JSON.parse(localStorage.getItem("profileData"));
  const phone_number = profileData?.data?.phone_number;



  useEffect(() => {
    loadData(1);
  }, []);

  useEffect(() => {
    loadData(page);
  }, [page]);

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && !isLoading) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const loadData = async (page) => {
    await loadNotifications(page);
  };
const Data = JSON.parse(localStorage.getItem("LOGIN_DATA"));

  const loadNotifications = async (page) => {
    try {
      setIsLoading(true);
      const requestBody = {
        page: page,
        page_size: 10,
        phone_number:Data.phone_number,
      };

    //   const response = await axios.post(ApiConfig.GET_NOTIFICATIONS, requestBody);
          const response = await PostCallWithErrorResponse(ApiConfig?.GET_NOTIFICATIONS ,JSON.stringify(requestBody));
    
      const res = response.json;

      if (res?.success) {
        const data = [...notificationList, ...res?.data];
        setNotificationList(data);

        const today = moment().format("YYYY-MM-DD");
        const filterToday = data.filter(
          (i) => i?.date_time?.split(" ")?.[0] === today
        );
        const filterEarly = data.filter(
          (i) => i?.date_time?.split(" ")?.[0] !== today
        );

        setNotificationListToday(filterToday);
        setNotificationListEarly(filterEarly);
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        
        <h2 style={styles.headerTitle}>Notifications</h2>
        <div style={{ width: "30px" }} />
      </div>

      {/* Scrollable Notifications */}
      <div
        style={styles.scrollContainer}
        onScroll={handleScroll}
        ref={scrollRef}
      >
        {/* Today Section */}
        <h3 style={styles.sectionTitle}>Today</h3>
        {notificationListToday.length > 0 ? (
          notificationListToday.map((data, index) => (
            <div key={index} style={styles.notificationCard}>
              <div style={styles.iconCircle}>🔔</div>
              <div style={{ flex: 1 }}>
                <h4 style={styles.title}>
                  {data?.notification_title ?? "Notification"}
                </h4>
                <p style={styles.body}>{data?.notification_body}</p>
                <p style={styles.date}>{data?.date_time}</p>
              </div>
            </div>
          ))
        ) : (
          <p style={styles.emptyText}>No new notifications today.</p>
        )}

        {/* Earlier Section */}
        <h3 style={styles.sectionTitle}>Earlier</h3>
        {notificationListEarly.length > 0 ? (
          notificationListEarly.map((data, index) => (
            <div key={index} style={styles.notificationCard}>
              <div style={styles.iconCircle}>🔔</div>
              <div style={{ flex: 1 }}>
                <h4 style={styles.title}>
                  {data?.notification_title ?? "Notification"}
                </h4>
                <p style={styles.body}>{data?.notification_body}</p>
                <p style={styles.date}>{data?.date_time}</p>
              </div>
            </div>
          ))
        ) : (
          <p style={styles.emptyText}>No earlier notifications.</p>
        )}
      </div>
    </div>
  );
};

export default Notification;

// 💅 Inline Styles
const styles = {
  container: {
    backgroundColor: "#f5f7fa",
    minHeight: "100vh",
    paddingBottom: "50px",
    fontFamily: "Arial, sans-serif",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "white",
    padding: "20px 30px",
    borderBottomLeftRadius: "30px",
    borderBottomRightRadius: "30px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  backButton: {
    border: "none",
    background: "none",
    fontSize: "22px",
    cursor: "pointer",
  },
  headerTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#152F4E",
  },
  scrollContainer: {
    padding: "20px 30px",
    overflowY: "auto",
    maxHeight: "calc(100vh - 140px)",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#152F4E",
    marginTop: "20px",
    marginBottom: "10px",
  },
  notificationCard: {
    display: "flex",
    backgroundColor: "white",
    borderRadius: "20px",
    padding: "15px",
    paddingBottom: '0',
    marginBottom: "10px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    alignItems: "center",
  },
  iconCircle: {
    backgroundColor: "#e0ebff",
    borderRadius: "50%",
    height: "45px",
    width: "45px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    marginRight: "15px",
    marginTop:"-30px"
  },
  title: {
    fontSize: "15px",
    fontWeight: "bold",
    color: "#152F4E",
    marginBottom: "5px",
  },
  body: {
    fontSize: "14px",
    color: "#2c3e50",
    marginBottom: "8px",
  },
  date: {
    fontSize: "12px",
    color: "#7f8c8d",
    textAlign: "right",
    marginBottom: '8px',
  },
  emptyText: {
    fontSize: "14px",
    color: "#999",
    marginTop: "10px",
  },
};
